import request from '../utils/request'
import service from '../config/services'

const { domain: { jimuai } } = service

//test data ======start===============
export function getBenefitOutletMenuModel(data) {
  return request({
    url: `${jimuai}/prod-api/api/benefitOutletMenu`,
    params: data,
    method: 'get',
    hideError: true,
  })
}

export function getMyBenefitModel(data) {
  return request({
    url: `${jimuai}/prod-api/api/myBenefit`,
    params: data,
    method: 'get',
    hideError: true,
  })
}

export function getBenefitByBindCodeModel(data) {
  return request({
    url: `${jimuai}/prod-api/api/benefitByBindCode`,
    params: data,
    method: 'get',
    hideError: true,
  })
}
//getTodayConsumeModel
export function getTodayConsumeModel(data) {
  return request({
    url: `${jimuai}/prod-api/api/todayConsume`,
    params: data,
    method: 'get',
    hideError: true,
  })
}

//test data ======end===============

//绑定权益
export function bindBenefitModel(data) {
  return request({
    url: `${jimuai}/prod-api/api/packageBind`,
    data,
    method: 'post',
    hideError: true,
  })
}

//checkPackageBind
export function checkPackageBindModel(data) {
  return request({
    url: `${jimuai}/prod-api/api/checkPackageBind`,
    params: data,
    method: 'get',
    hideError: true,
  })
}

export function getPackageDetailModel(data) {
  return request({
    url: `${jimuai}/prod-api/api/packageDetail`,
    params: data,
    method: 'get',
    hideError: true,
  })
}

///api/getPackageCouponDetail
export function getPackageCouponDetailModel(data) {
  return request({
    url: `${jimuai}/prod-api/api/getPackageCouponDetail`,
    params: data,
    method: 'get',
    hideError: true,
  })
}

const memberPackagesInflight = new Map()

// 获取会员套餐。菜单可见性与悬浮入口会同时读取，合并同一次进行中的请求。
export function getMemberPackagesModel(data) {
  const key = `${data?.memberId || ''}|${data?.language || ''}`
  const pending = memberPackagesInflight.get(key)
  if (pending) return pending

  const requestPromise = request({
    url: `${jimuai}/prod-api/api/getMemberPackages`,
    params: data,
    method: 'get',
    hideError: true,
  }).finally(() => {
    memberPackagesInflight.delete(key)
  })

  memberPackagesInflight.set(key, requestPromise)
  return requestPromise
}

// 获取会员套餐商家菜品分页列表
// /prod-api/api/getPackageMerchantCouponProducts?packageRuleMerchantId=95&pageNum=2&pageSize=2&language=en_US
export function getPackageMerchantCouponProductsModel(data) {
  return request({
    url: `${jimuai}/prod-api/api/getPackageMerchantCouponProducts`,
    params: data,
    method: 'get',
    hideError: true,
  });
}